import { updateAuthenticationInfoStorageReference } from '@/contexts/AuthContext/utils/getAuthenticationInfoFromStorage';
import axios from 'axios';

// intercepting to capture errors
axios.interceptors.response.use(
  (response: any) => {
    return response.data ? response.data : response;
  },
  (error: any) => {
    if (axios.isAxiosError(error) && error.response && error.response.status === 401) {
      updateAuthenticationInfoStorageReference(null);
      window.location.href = '/login';
      return;
    }
    if (axios.isAxiosError(error)) {
      const err = axios.isAxiosError(error) && error.response && error.response.data ? error.response?.data : error;
      return Promise.reject(err);
    }

    return Promise.reject(
      (error && error.message) || {
        message: 'Serviço indisponível no momento. Por favor, tente novamente em alguns instantes',
      },
    );
  },
);
